// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var isV3 = allVue.version && allVue.version[0] === '3';
import { classNames } from '@progress/kendo-vue-common';
import { getItemValue } from './utils';
/**
 * @hidden
 */

var ListDefaultItemVue2 = {
  name: 'list-default-item',
  props: {
    defaultItem: [Object, String],
    textField: String,
    selected: Boolean
  },
  // @ts-ignore
  setup: !isV3 ? undefined : function () {
    var v3 = !!isV3;
    return {
      v3: v3
    };
  },
  methods: {
    onMouseDown: function onMouseDown(e) {
      e.preventDefault();
    },
    onClick: function onClick(e) {
      this.$emit('defaultitemclick', e);
    }
  },
  // @ts-ignore
  render: function render(createElement) {
    var h = gh || createElement;
    var _a = this.$props,
        selected = _a.selected,
        defaultItem = _a.defaultItem,
        textField = _a.textField;
    return h("div", {
      onClick: this.onClick,
      on: this.v3 ? undefined : {
        "click": this.onClick,
        "mousedown": this.onMouseDown
      },
      onMousedown: this.onMouseDown,
      style: {
        position: 'unset'
      },
      "class": classNames('k-list-optionlabel', {
        'k-selected': selected
      })
    }, [getItemValue(defaultItem, textField) || '']);
  }
};
/**
 * @hidden
 */

var ListDefaultItem = ListDefaultItemVue2;
export { ListDefaultItem, ListDefaultItemVue2 };